import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * MicrosoftOAuthContext provides context for Microsoft OAuth authentication.
 *
 * @typedef {Object} MicrosoftOAuthContextValue
 */

/**
 * Context for Microsoft OAuth authentication.
 */
export const MicrosoftOAuthContext = createContext();

/**
 * MicrosoftOAuthProvider component provides the Microsoft OAuth context to its children.
 *
 * @param {Object} props - The component props.
 * @param {*} props.value - The value to be passed to the context consumers.
 * @param {React.ReactNode} props.children - The child components that will consume the context.
 * @returns {JSX.Element} MicrosoftOAuthProvider component.
 */
export function MicrosoftOAuthProvider({ value, children }) {
	return (
		<MicrosoftOAuthContext.Provider value={value}>
			{children}
		</MicrosoftOAuthContext.Provider>
	);
}

MicrosoftOAuthProvider.propTypes = {
	value: PropTypes.any,
	children: PropTypes.node.isRequired,
};
